import { __spread, __decorate, __metadata } from 'tslib';
import { Input, Output, Component, ViewEncapsulation, ChangeDetectorRef, EventEmitter, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UIKitIconsModule } from '@uikit/components/uk-icons';

var SidenavComponent = /** @class */ (function () {
    function SidenavComponent(_router, cdr) {
        this._router = _router;
        this.cdr = cdr;
        this.side = 'left';
        this.toggleChange = new EventEmitter();
    }
    SidenavComponent.prototype.ngOnChanges = function (changes) {
        var change = changes['navigationList'];
        if (change && change.currentValue) {
            this.navigationList = __spread(change.currentValue);
            this.cdr.detectChanges();
        }
    };
    SidenavComponent.prototype.onMenuLinkClick = function (menuItem) {
        this.navigationList.forEach(function (menu) { if (menu.subMenu && menu !== menuItem)
            menu.toggleSubMenu = false; });
        menuItem.subMenu
            ? (menuItem.toggleSubMenu = !menuItem.toggleSubMenu)
            : this._router.navigate([menuItem.linkSref]);
        this.cdr.detectChanges();
    };
    SidenavComponent.prototype.onCloseClick = function () {
        this.cdr.detectChanges();
        this.toggleChange.emit(false);
    };
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], SidenavComponent.prototype, "navigationList", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SidenavComponent.prototype, "side", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], SidenavComponent.prototype, "toggle", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], SidenavComponent.prototype, "toggleChange", void 0);
    SidenavComponent = __decorate([
        Component({
            selector: 'uk-sidenav',
            template: "<nav class=\"uk-sidenav uk-shadow-2 open\" [ngClass]=\"{'left': side === 'left', 'right' : side === 'right', 'open': toggle }\">\r\n  <button aria-label=\"close\" class=\" uk-sidenav__close\" [ngClass]=\"side\" ukIcon=\"close\" (click)=\"onCloseClick()\">\r\n  </button>\r\n  <ul class=\"uk-sidenav__menu\">\r\n    <li *ngFor=\"let nav of navigationList\">\r\n      <a class=\"uk-sidenav__menu-link finline fcol-sm-12\" (click)=\"onMenuLinkClick(nav)\">\r\n        {{nav.linkText}}\r\n        <i *ngIf=\"nav.subMenu\" class=\"arrow\" [class.open]=\"nav.toggleSubMenu\">\r\n          <span class=\"arrow-left\"></span>\r\n          <span class=\"arrow-right\"></span>\r\n        </i>\r\n      </a>\r\n      <div *ngIf=\"nav.subMenu\" [class.hide]=\"!nav.toggleSubMenu\" class=\"uk-sidenav__submenu\">\r\n        <ul class=\"uk-sidenav__menu\">\r\n          <li *ngFor=\"let subnav of nav.subMenu\">\r\n            <a class=\"uk-sidenav__menu-link finline fcol-sm-12\" (click)=\"onMenuLinkClick(subnav)\">\r\n              {{subnav.linkText}}\r\n            </a>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n",
            encapsulation: ViewEncapsulation.None
        }),
        __metadata("design:paramtypes", [Router, ChangeDetectorRef])
    ], SidenavComponent);
    return SidenavComponent;
}());

var UIKitSidenavModule = /** @class */ (function () {
    function UIKitSidenavModule() {
    }
    UIKitSidenavModule = __decorate([
        NgModule({
            imports: [CommonModule, UIKitIconsModule],
            exports: [SidenavComponent],
            declarations: [SidenavComponent]
        })
    ], UIKitSidenavModule);
    return UIKitSidenavModule;
}());

/**
   * Fields of MenuItem
   * @param linkText Text to show
   * @param linkSref Link to redirect
   * @param isActive Class to render if is active
   * @param subMenu an instance of MenuItem
   * @param onClick
   * @param toggleSubMenu hide subMenu
   * @param icon
   */
var MenuItem = /** @class */ (function () {
    function MenuItem() {
    }
    return MenuItem;
}());

export { MenuItem, UIKitSidenavModule, SidenavComponent as ɵa };
//# sourceMappingURL=uikit-components-uk-sidenav.js.map
